"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var WHITELIST_REGEXP = /^[a-zA-Z0-9 .,\-()\r\n?+=!:@*\xC0-\xFF]*$/;
exports.whitelistValidator = {
    name: 'whitelist',
    instant: true,
    validation: function (value) {
        return utils_1.isEmpty(value) || WHITELIST_REGEXP.test(value);
    },
};
//# sourceMappingURL=WhitelistValidator.js.map